module.exports = __webpack_public_path__ + "img/indu_6.95a70d7b.png";